// 此函数主要用于将组件和页面进行连接
// 并在开发环境的时候进行热更新的配置
import React from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';

// import { APIHOST } from '../config/';

import { AppContainer } from 'react-hot-loader';
import Routes from './routes';

const render = function(Component) {
    ReactDOM.render(
        <AppContainer>
            <Component />
        </AppContainer>,
        document.getElementById('root'),
    );
};

render(Routes);

if (module.hot) {
    module.hot.accept('./routes', function() {
        render(Routes);
    });
}



// WEBPACK FOOTER //
// ./index.js